import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from 'axios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { getTax, getTax_v2 } from '../utils/dropdownlist';

class PosTaxForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isGlobal: true,
      taxList: [],
      tax_id: '',
      store_id: '',
      company_id: '',
      tax_code: '',
      name: '',
      rate: '',
      reg_no: '',
      inclusive: 0,
      options: '',
    };
  }

  componentDidMount() {
    //getTax.call(this);
    this.getTaxList();
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId;
        const data = this.props.data.taxList.find(e => e.id === id);
        this.setState({
          id: id,
          tax_code: data.tax_code,
          name: data.name,
          company_id: data.company_id,
          rate: data.rate,
          reg_no: data.reg_no,
          inclusive: data.inclusive,
          options: data.options,
          isEdit: true,
        });
      }
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getTaxList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v1/tax', data)
      .then(response => {
        const result = response.data;
        const storeTax = this.props.data.taxList;

        let TaxOp = result.data.filter(x => !storeTax.some(y => y.id === x.id));

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({ taxList: TaxOp });
        }
      })
      .catch(error => {
        console.log(error);
        alert(error);
      });
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkboxChangeHandler = event => {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.editTax(user, comp, url);
      } else {
        this.createTax(user, comp, url);
      }
    } else {
      this.addStoreTax(user, comp, url);
    }
  };

  createTax(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      company_id: comp.CompanyID,
      tax_code: this.state.tax_code,
      name: this.state.name,
      rate: this.state.rate,
      reg_no: this.state.reg_no,
      inclusive: this.state.inclusive ? '1' : '0',
      options: this.state.options,
      update_by: user.email,
    };
    axios
      .post(url + ':3001/v1/tax/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Tax details updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message);
        } else {
          alert('Error', error.message);
        }
      });
  }

  editTax(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      tax_code: this.state.tax_code,
      name: this.state.name,
      rate: this.state.rate,
      reg_no: this.state.reg_no,
      inclusive: this.state.inclusive ? '1' : '0',
      options: this.state.options,
      created_by: user.email,
    };
    axios
      .post(url + ':3001/v1/tax/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New tax added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message);
        }
        // else if (error.request) {
        //   console.log(error.request);
        // }
        else {
          alert('Error', error.message);
        }
      });
  }

  addStoreTax(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      company_id: comp.CompanyID,
      tax_id: this.state.tax_id,
      added_by: user.email,
    };
    axios
      .post(url + ':3001/v1/store/tax/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Tax added successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message);
        } else {
          alert('Error', error.message);
        }
      });
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Tax {this.state.isGlobal ? 'Details' : 'List'}
        </ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="tax_code">Tax Code</Label>
                  <Input
                    type="text"
                    name="tax_code"
                    value={this.state.tax_code}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="rate">Rate</Label>
                  <Input
                    type="text"
                    name="rate"
                    value={this.state.rate}
                    onChange={this.changeHandler}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="reg_no">Reg No.</Label>
                  <Input
                    type="text"
                    name="reg_no"
                    value={this.state.reg_no}
                    onChange={this.changeHandler}
                  />
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      name="inclusive"
                      checked={this.state.inclusive}
                      onChange={this.checkboxChangeHandler}
                    />{' '}
                    Inclusive
                  </Label>
                </FormGroup>
                <br />
                {/* <FormGroup>
                  <Label for="options">Options</Label>
                  <Input
                    type="text"
                    name="options"
                    value={this.state.options}
                    onChange={this.changeHandler}
                  />
                </FormGroup> */}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input
                    type="select"
                    name="tax_id"
                    onChange={this.changeHandler}
                    required
                  >
                    <option></option>
                    {this.state.taxList &&
                      this.state.taxList.length > 0 &&
                      this.state.taxList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.tax_code}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default PosTaxForm;
